import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, profile } from 'config/config'; // Importing configuration settings
import { providersCasino } from 'config/config'; // Importing casino providers configuration
import { gamesCasino } from 'config/config'; // Importing casino games configuration

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for date range selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker for selecting a date
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'), // Label for the datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date is today
                                },
                            },
                        },
                        {
                            view: 'text', // Text input for identifier
                            name: 'Identifier',
                            label: _('Identificador'), // Label for the identifier input
                            labelPosition: 'top',
                            placeholder: _('Identificador'), // Placeholder text
                        },
                        {
                            view: 'combo', // Combo box for selecting a provider
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'), // Label for the provider combo
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Function to fetch provider options
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect', // API endpoint for fetching providers
                                                    '{"Filter":"' + text + '"}', // Request body with filter
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse the response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse the data into the combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for selecting a product
                            name: 'ProductId',
                            label: _('Producto'), // Label for the product combo
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Function to fetch product options
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect', // API endpoint for fetching products
                                                    '{"Filter":"' + text + '"}', // Request body with filter
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse the response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse the data into the combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'radio', // Radio buttons for selecting report type
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Label for the type selection
                            labelPosition: 'top',
                            height: screen.width > 500 && screen.height > 500 ? 0 : 100, // Adjust height based on screen size
                            value: 1, // Default selected value
                            options: [
                                { id: 0, value: _('Detallado') }, // Detailed report option
                                { id: 1, value: _('Totales') }, // Total report option
                            ],
                        },
                        {
                            view: 'richselect', // Rich select for selecting state
                            name: 'State',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for the state selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                {
                                    id: 'A',
                                    value: _('Abiertas'), // Open state option
                                },
                                {
                                    id: 'C',
                                    value: _('Cerradas'), // Closed state option
                                },
                            ],
                        },
                        {
                            view: "multicombo", name: "VerticalsId", minWidth: 200,
                            label: _("Vertical"), labelPosition: "top",
                            placeholder: _("Seleccionar vertical(es)"),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "es/Select/GetCasinoVerticals", '{"Filter":"'+text+'"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message("Error!");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var resp = JSON.parse(text);
                                                if (!resp.HasError) {
                                                    vthis.clearAll();
                                                    vthis.add({ id: "0", value: "Todas" });
                                                    vthis.parse(resp.Data);
                                                }
                                            }
                                        });
                                    }
                                }
                            },
                            value: "0",
                            on: {
                                onChange: function(newv, oldv) {
                                    const toArray = v => Array.isArray(v) ? v : (v ? v.split(",") : []);
                                    const newArr = toArray(newv);
                                    const oldArr = toArray(oldv);

                                    // Si "Todas" estaba seleccionada y el usuario intenta dejarlo vacío, la volvemos a poner
                                    if (newArr.length === 0 && oldArr.includes("0")) {
                                        return this.setValue("0");
                                    }

                                    // Si seleccionan "Todas", se deseleccionan las demás
                                    if (newArr.includes("0") && !oldArr.includes("0")) {
                                        return this.setValue("0");
                                    }

                                    // Si "Todas" estaba seleccionada y seleccionan otra opción, quitamos "Todas"
                                    if (oldArr.includes("0") && newArr.some(v => v !== "0")) {
                                        const withoutZero = newArr.filter(v => v !== "0");
                                        return this.setValue(withoutZero);
                                    }

                                    // Si intentan quitar manualmente "Todas" pero no han seleccionado nada más, la reponemos
                                    if (!newArr.includes("0") && oldArr.includes("0") && newArr.length === 0) {
                                        return this.setValue("0");
                                    }

                                    if (!newArr.includes("0") && oldArr.length === 1 && !oldArr.includes("0") && newArr.length === 0) {
                                        return this.setValue("0");
                                    }
                                },
                                onAfterRender: function() {
                                    var list = this.getPopup().getList();
                                    if (list.count() === 0) {
                                        var vthis = list;
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "es/Select/GetCasinoVerticals", '{"Filter":""}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message("Error!");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var resp = JSON.parse(text);
                                                if (!resp.HasError) {
                                                    vthis.clearAll();
                                                    vthis.add({ id: "0", value: "Todas" });
                                                    vthis.parse(resp.Data);
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        },
                        { gravity: 2, id: 'grav', minWidth: 200 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    width: 140,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'),
                    type: 'form',
                    width: 140,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to submit the second form
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to submit
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filter sections
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the filters section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for the filter popup
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section in the scroll view
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the popup
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Second form for filters
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        return {
            view: 'form', // Main form for the view
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section on larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide gravity element on small screens
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
